/****************************************************
 * Module Name:  labTest.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import * as React from "react";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import LabNewTest from "./labNewTest";
import LabTesting from "./labTesting";
import PropTypes from "prop-types";
import { useMediaQuery } from "@mui/material";
import LabReportReceived from "./labReportReceived";
import LabStoneReceived from "./labStoneReceived";
import LabApproveReject from "./labApproveReject";
import Constants from "../../utility/constants";
import { ImBoxAdd } from "react-icons/im";
import { FaMoneyCheckAlt } from "react-icons/fa";
import { IoMdPricetags } from "react-icons/io";
import DiamondIcon from "@mui/icons-material/Diamond";
import ThumbsUpDownIcon from "@mui/icons-material/ThumbsUpDown";
import BiotechIcon from "@mui/icons-material/Biotech";
import FiberNewIcon from "@mui/icons-material/FiberNew";
import SummarizeIcon from "@mui/icons-material/Summarize";
import LabTagging from "./labTagging";
import LabPricing from "./labPricing";
import LabPricingApproval from "./labPricingApproval";
import StoneAvailable from "./stoneAvailable";
import NoPermission from "../common/noPermission";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 1 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
    value: index,
  };
}

export default function LabTest() {
  const theme = useTheme();
  const [value, setValue] = React.useState(
    Constants.USER_PERMISSION.find(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.OPERATION_LAB_NEWTEST
    ) !== undefined
      ? 0
      : Constants.USER_PERMISSION.find(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.OPERATION_LAB_LABTESTING
      ) !== undefined
        ? 1
        : Constants.USER_PERMISSION.find(
          (iPermission) =>
            iPermission.permissionid ===
            Constants.PERMISSIONS.OPERATION_LAB_REPORTRECEIVED
        ) !== undefined
          ? 2
          : Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_STONERECEIVED
          ) !== undefined
            ? 3
            : Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_APPROVEREJECT
            ) !== undefined
              ? 4
              : Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.OPERATION_LAB_PRICING
              ) !== undefined
                ? 5
                : Constants.USER_PERMISSION.find(
                  (iPermission) =>
                    iPermission.permissionid ===
                    Constants.PERMISSIONS.OPERATION_LAB_PRICINGAPPROVAL
                ) !== undefined
                  ? 6
                  : Constants.USER_PERMISSION.find(
                    (iPermission) =>
                      iPermission.permissionid ===
                      Constants.PERMISSIONS.OPERATION_LAB_TAGGING
                  ) !== undefined
                    ? 7
                    : Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.OPERATION_LAB_AVAILABLE
                    ) !== undefined
                      ? 8
                      : 9
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const matches = useMediaQuery("(min-width:1500px)");

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    value === 9 ? <NoPermission /> :
      <Box sx={{ bgcolor: "background.paper", width: "100%", padding: "10px" }}>
        <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant={matches ? "fullWidth" : "scrollable"}
            scrollButtons="auto"
            aria-label="full width tabs example"
            sx={{
              "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                color: "#212121",
                fontWeight: "bold",
                textAlign: 'center'
              },
              "& .MuiTab-root": {
                paddingBottom: 4
              },
              "& .Mui-selected": {
                bgcolor: "#0277bd !important",
                color: "#fafafa !important",
                fontWeight: "bold !important",
                paddingBottom: 4
              }
            }}
            TabIndicatorProps={{ style: { background: "#0277bd" } }}
          >
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_NEWTEST
            ) !== undefined ? (
              <Tab
                icon={<FiberNewIcon />}
                iconPosition="start"
                label="New Test"
                {...a11yProps(0)}
              />
            ) : null}
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_LABTESTING
            ) !== undefined ? (
              <Tab
                icon={<BiotechIcon />}
                iconPosition="start"
                label="Lab Testing"
                {...a11yProps(1)}
              />
            ) : null}
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_REPORTRECEIVED
            ) !== undefined ? (
              <Tab
                icon={<SummarizeIcon />}
                iconPosition="start"
                label="Report Rec."
                {...a11yProps(2)}
              />
            ) : null}
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_STONERECEIVED
            ) !== undefined ? (
              <Tab
                icon={<ImBoxAdd size={20} />}
                iconPosition="start"
                label="Stone Rec."
                {...a11yProps(3)}
              />
            ) : null}
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_APPROVEREJECT
            ) !== undefined ? (
              <Tab
                icon={<ThumbsUpDownIcon />}
                iconPosition="start"
                label="Approve/Reject"
                {...a11yProps(4)}
              />
            ) : null}
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_PRICING
            ) !== undefined ? (
              <Tab
                icon={<FaMoneyCheckAlt size={23} />}
                iconPosition="start"
                label="Pricing"
                {...a11yProps(5)}
              />
            ) : null}
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_PRICINGAPPROVAL
            ) !== undefined ? (
              <Tab
                icon={<FaMoneyCheckAlt size={23} />}
                iconPosition="start"
                label="Pricing Apv."
                {...a11yProps(6)}
              />
            ) : null}
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_TAGGING
            ) !== undefined ? (
              <Tab
                icon={<IoMdPricetags size={22} />}
                iconPosition="start"
                label="Tagging"
                {...a11yProps(7)}
              />
            ) : null}
            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_LAB_AVAILABLE
            ) !== undefined ? (
              <Tab
                icon={<DiamondIcon size={22} />}
                iconPosition="start"
                label="Stone Avail."
                {...a11yProps(8)}
              />
            ) : null}
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_NEWTEST
          ) !== undefined ? (
            <TabPanel value={value} index={0}>
              <LabNewTest />
            </TabPanel>
          ) : null}
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_LABTESTING
          ) !== undefined ? (
            <TabPanel value={value} index={1}>
              <LabTesting />
            </TabPanel>
          ) : null}
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_REPORTRECEIVED
          ) !== undefined ? (
            <TabPanel value={value} index={2}>
              <LabReportReceived />
            </TabPanel>
          ) : null}
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_STONERECEIVED
          ) !== undefined ? (
            <TabPanel value={value} index={3}>
              <LabStoneReceived />
            </TabPanel>
          ) : null}
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_APPROVEREJECT
          ) !== undefined ? (
            <TabPanel value={value} index={4}>
              <LabApproveReject />
            </TabPanel>
          ) : null}
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_PRICING
          ) !== undefined ? (
            <TabPanel value={value} index={5}>
              <LabPricing />
            </TabPanel>
          ) : null}
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_PRICINGAPPROVAL
          ) !== undefined ? (
            <TabPanel value={value} index={6}>
              <LabPricingApproval />
            </TabPanel>
          ) : null}
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_TAGGING
          ) !== undefined ? (
            <TabPanel value={value} index={7}>
              <LabTagging />
            </TabPanel>
          ) : null}
          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_LAB_AVAILABLE
          ) !== undefined ? (
            <TabPanel value={value} index={8}>
              <StoneAvailable />
            </TabPanel>
          ) : null}
        </SwipeableViews>
      </Box>
  );
}
